
import {CustomerDetailsType} from "./customerdetailstype";

export const CustomerdetailsData = [
    {
        id: 1,
        name: 'Fernandez Moledo, Inc #3',
        customer_number: 'A00015',
        type:'Customer Type',
        last_visit:'24 days since last visit',
        total_sales:'$ 803,774.94',
        sales_in_90_days:'$ 15,0025.36',
        available_Credit:'$14,750.00',
        open_order:'$2,500.00',
        amount_invoiced:'$15,250.00',
        amount_overdue:'$250.00',
        credit_limit:'$30,000',
        payment_term:'NET 15',
        payment_method:'Invoices',
        price_list:'GF',
        street_name:'Street Name',
        city:'city',
        state:'state',
        zipcode:'zipcode',
 
    }
 


];


export const CustomerdetailsOpenOrder = [
    {
        id: 1,
        order_number: '123456',
        order_amount: '803,774.94',
        date: 'June 12, 2016',
        status: 'Open',
 
    },
     {
        id: 2,
        order_number: '123456',
        order_amount: '803,774.94',
        date: 'June 13, 2016',
        status: 'Open',
 
    },
     {
        id: 3,
        order_number: '123456',
        order_amount: '803,774.94',
        date: 'June 14, 2016',
        status: 'Open',
 
    }


];






// WEBPACK FOOTER //
// ./src/app/Customerdashboard/customerdetailsData.ts